import { Controller } from "@hotwired/stimulus";
import { Loader } from "@googlemaps/js-api-loader";

export default class extends Controller {
  static targets = ["map"];

  connect() {
    this.newMap();
  }

  // 地図を表示させる関数
  newMap() {
    const loader = this.setLoader();
    loader.load().then(async () => {
      const { Map } = await window.google.maps.importLibrary("maps");
      // 緯度経度をFloat型に変換
      this._location = Object.fromEntries(
        Object.entries(JSON.parse(this.mapTarget.dataset.json)).map(([key, value]) => [key, parseFloat(value)]),
      );
      this._map = new Map(this.mapTarget, {
        center: { lat: this._location.lat, lng: this._location.lng },
        zoom: 15,
      });
      new window.google.maps.Marker({
        map: this._map,
        position: this._location,
      });
    });
  }

  // 地図の設定
  setLoader() {
    return new Loader({
      apiKey: document.head.querySelector("meta[name=google_api_key]").content,
      version: "weekly",
    });
  }
}
